export default __webpack_public_path__ + "static/media/searchDots.77246585.svg";